import axios from "axios";
import router from "@/router";
import Qs from "qs";
import {Dialog} from "vant";
import utils from '../libs/utils';
class HttpRequest {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.queue = {};
    }
    getInsideConfig() {
        return {
            baseURL: this.baseUrl,
            timeout: 10e3,
        };
    }

    destroy(url) {
        delete this.queue[url];
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {               
                var token = window.localStorage.getItem('token');
                if (!token) token = "";
                if (token) {
                    config.headers.common['Authorization'] = 'Bearer ' + token;
                    if(!config.params) config.params = {}
                    config.params = Object.assign(config.params, { token });
                }
                
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
        // 响应拦截
        instance.interceptors.response.use(
            res => {
                this.destroy(url);
                const {data} = res;
                if (data.status == 200 || data.statusCode == 200) {
                    //!!TODO move 定制
                } else if (data.status == 201 || data.status == 401) {
                    router.replace({ path: "/login" });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: data.message
                    })
                }

                return Promise.resolve(data);
            },
            error => {
                let message = error.message;
                if (error.message.indexOf("timeout of") != -1) {
                    message = "请求超时，请刷新页面再试";
                }
                // router.replace({ path: "/login" });
                this.destroy(url);
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}

export default HttpRequest;
